(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('track-order')) {
    customElements.define(
      'track-order',
      class TrackOrder extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('.track-order__input');
          this.message = this.querySelector('.track-order__message');
          this.result = this.querySelector('.track-order__result');
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.track();
          });

          const number = new URLSearchParams(window.location.search).get('tracking');
          if (number) {
            this.input.value = number;
            this.track();
          }
        }

        showMessage(text) {
          this.message.textContent = text;
          this.message.hidden = !text;
          this.input.setAttribute('aria-invalid', text ? 'true' : 'false');
        }

        loadWidget() {
          if (window.YQV5) return Promise.resolve();
          if (!TrackOrder.widget) {
            TrackOrder.widget = new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = 'https://www.17track.net/externalcall.js';
              script.onload = resolve;
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }
          return TrackOrder.widget;
        }

        track() {
          const number = this.input.value.trim();
          if (!number) {
            this.showMessage(this.dataset.emptyMessage);
            this.input.focus();
            return;
          }
          this.showMessage('');
          this.result.hidden = false;
          this.loadWidget().then(() => {
            window.YQV5.trackSingle({
              YQ_ContainerId: this.result.id,
              YQ_Height: parseInt(this.dataset.height, 10) || 560,
              YQ_Fc: '0',
              YQ_Lang: document.documentElement.lang || 'en',
              YQ_Num: number,
            });
            this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-carousel')) {
    customElements.define(
      'video-carousel',
      class VideoCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.video-carousel__track');
          this.originals = Array.from(this.track.children);
          this.controls = this.querySelector('.video-carousel__controls');
          this.dots = this.querySelector('.video-carousel__dots');
          this.arrows = this.querySelectorAll('.video-carousel__arrow');
          this.autoplay =
            this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          // Autoplaying videos only run while they are on screen.
          this.observer = new IntersectionObserver(
            (entries) =>
              entries.forEach((entry) => {
                const video = entry.target.querySelector('video');
                if (!video) return;
                if (!entry.isIntersecting) {
                  video.pause();
                } else if (this.autoplay && video.muted) {
                  video.play().catch(() => {});
                }
              }),
            { threshold: 0.6 }
          );

          this.arrows.forEach((arrow) =>
            arrow.addEventListener('click', () => this.goTo(this.index() + Number(arrow.dataset.step)))
          );
          this.track.addEventListener(
            'scroll',
            () => {
              this.update();
              clearTimeout(this.settleTimer);
              this.settleTimer = setTimeout(() => this.wrap(), 120);
            },
            { passive: true }
          );
          window.addEventListener('resize', (this.onResize = () => this.setup()));
          this.setup();
        }
        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          window.removeEventListener('resize', this.onResize);
          clearTimeout(this.settleTimer);
        }
        // Adds a copy of every video before and after the real ones when
        // looping, so the last video is followed by the first one.
        setup() {
          this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
          this.observer.disconnect();
          const count = this.originals.length;
          this.slides = this.originals;
          this.loop = false;
          if (this.dataset.loop === 'true' && count > 1 && this.track.scrollWidth > this.track.clientWidth + 2) {
            const copy = () =>
              this.originals.map((slide) => {
                const clone = slide.cloneNode(true);
                clone.dataset.clone = '';
                clone.removeAttribute('data-shopify-editor-block');
                clone.setAttribute('aria-hidden', 'true');
                clone.querySelectorAll('button').forEach((button) => (button.tabIndex = -1));
                return clone;
              });
            this.track.prepend(...copy());
            this.track.append(...copy());
            this.slides = Array.from(this.track.children);
            this.loop = true;
          }
          this.offset = this.loop ? count : 0;
          this.slides.forEach((slide) => {
            this.bindSlide(slide);
            this.observer.observe(slide);
          });
          this.jump(this.offset);
          this.buildDots();
        }
        bindSlide(slide) {
          const video = slide.querySelector('video');
          if (!video || slide.vcBound) return;
          slide.vcBound = true;
          slide.classList.remove('is-playing');
          this.setMuted(slide, true);
          video.addEventListener('play', () => slide.classList.add('is-playing'));
          video.addEventListener('pause', () => slide.classList.remove('is-playing'));
          slide.querySelector('.video-carousel__play').addEventListener('click', () => this.togglePlay(slide));
          const sound = slide.querySelector('.video-carousel__sound');
          if (sound) sound.addEventListener('click', () => this.toggleSound(slide));
        }
        togglePlay(slide) {
          const video = slide.querySelector('video');
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
        // Only one video plays with sound at a time.
        toggleSound(slide) {
          const video = slide.querySelector('video');
          const unmute = video.muted;
          this.slides.forEach((other) => {
            if (other !== slide && other.querySelector('video')) this.setMuted(other, true);
          });
          this.setMuted(slide, !unmute);
          if (unmute) video.play().catch(() => {});
        }
        setMuted(slide, muted) {
          slide.querySelector('video').muted = muted;
          const sound = slide.querySelector('.video-carousel__sound');
          if (!sound) return;
          sound.setAttribute('aria-pressed', !muted);
          sound.setAttribute('aria-label', muted ? sound.dataset.labelOn : sound.dataset.labelOff);
        }
        get step() {
          return this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
        }
        // Number of scroll positions, so the last dot means the last card is in view.
        pages() {
          if (this.loop) return this.originals.length;
          if (!this.slides.length) return 0;
          return Math.max(1, Math.round((this.track.scrollWidth - this.track.clientWidth) / this.step) + 1);
        }
        position() {
          return Math.round(this.track.scrollLeft / this.step);
        }
        index() {
          if (this.loop) return this.position() - this.offset;
          return Math.min(this.position(), this.pages() - 1);
        }
        goTo(i) {
          const target = this.loop ? i : Math.max(0, Math.min(i, this.pages() - 1));
          this.track.scrollTo({ left: (target + this.offset) * this.step });
        }
        // Moves without animation, used to swap a copy for the real video.
        jump(position) {
          this.track.style.scrollBehavior = 'auto';
          this.track.style.scrollSnapType = 'none';
          this.track.scrollLeft = position * this.step;
          this.track.offsetHeight;
          this.track.style.scrollSnapType = '';
          this.track.style.scrollBehavior = '';
        }
        // Once scrolling stops on a copy, jumps to the matching real video
        // and carries over its playback so the swap can't be seen.
        wrap() {
          if (!this.loop) return;
          const count = this.originals.length;
          const position = this.position();
          let shift = 0;
          if (position < count) shift = count;
          if (position >= count * 2) shift = -count;
          if (!shift) return;
          this.slides.forEach((slide, i) => {
            const target = this.slides[i + shift];
            const video = slide.querySelector('video');
            if (!target || !video || video.paused) return;
            const targetVideo = target.querySelector('video');
            targetVideo.currentTime = video.currentTime;
            if (!video.muted) {
              this.setMuted(slide, true);
              this.setMuted(target, false);
            }
            targetVideo.play().catch(() => {});
          });
          this.jump(position + shift);
          this.update();
        }
        buildDots() {
          const pages = this.pages();
          this.controls.hidden = pages < 2 || (!this.loop && this.track.scrollWidth <= this.track.clientWidth + 2);
          this.dots.replaceChildren();
          for (let i = 0; i < pages; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.tabIndex = -1;
            dot.addEventListener('click', () => this.goTo(i));
            this.dots.appendChild(dot);
          }
          this.update();
        }
        update() {
          const pages = this.pages();
          const current = this.loop ? (((this.index() % pages) + pages) % pages) : this.index();
          Array.from(this.dots.children).forEach((dot, i) => dot.setAttribute('aria-current', i === current));
          this.arrows[0].disabled = !this.loop && current <= 0;
          this.arrows[1].disabled = !this.loop && current >= pages - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
